module.exports = __webpack_public_path__ + "static/media/best_price_guarantee.eac16149.png";